import React from "react";
import useFormBuilderState, { FormBuilderStateValue } from "./use-form-builder-state";

export type FormBuilderContextValue = FormBuilderStateValue & {
  existingQuestions: Record<string, string>;
};

const FormBuilderStateContext = React.createContext<FormBuilderContextValue | null>(null);

type ProviderProps = {
  content: string;
  existingQuestions: Record<string, string>;
  onApplyContent: (content: string) => void | Promise<void>;
  children: React.ReactNode;
};

export const FormBuilderStateProvider: React.FC<ProviderProps> = ({
  content,
  existingQuestions,
  onApplyContent,
  children,
}) => {
  const state = useFormBuilderState({ content, existingQuestions, onApplyContent });
  const value: FormBuilderContextValue = { ...state, existingQuestions };
  return (
    <FormBuilderStateContext.Provider value={value}>
      {children}
    </FormBuilderStateContext.Provider>
  );
};

export const useFormBuilderStateContext = (): FormBuilderContextValue => {
  const value = React.useContext(FormBuilderStateContext);
  if (!value) {
    throw new Error("useFormBuilderStateContext must be used within FormBuilderStateProvider");
  }
  return value;
};
